import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import { lighten, darken } from "@mui/material/styles";
import { keyframes } from "@mui/system";

// Definim animația pulse
const pulse = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(211, 47, 47, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0);
  }
`;

export default function DueDateBadge({ dueDate }) {
	if (!dueDate) return null;

	const today = new Date();
	const due = new Date(dueDate);
	const timeDiff = due.getTime() - today.getTime();
	const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

	let color;
	let variant;
	let shadow;
	let animation;

	if (daysDiff > 7) {
		color = "success";
		variant = "outlined";
		shadow = "0 2px 8px rgba(46, 125, 50, 0.3)";
		animation = 'none';
	} else if (daysDiff > 3) {
		color = "warning";
		variant = "filled";
		shadow = "0 2px 8px rgba(245, 124, 0, 0.3)";
		animation = 'none';
	} else {
		color = "error";
		variant = "filled";
		shadow = "0 2px 8px rgba(211, 47, 47, 0.4)";
		animation = `${pulse} 0.5s infinite`;
	}

	const StyledChip = styled(Chip)(({ theme }) => ({
		boxShadow: shadow,
		fontWeight: 600,
		...(variant === "outlined" && {
			borderColor: lighten(theme.palette[color].main, 0.3),
			backgroundColor: lighten(theme.palette[color].main, 0.9),
		}),
		...(variant === "filled" && {
			color: theme.palette[color].contrastText,
		}),
	}));

	return (
		<StyledChip
			label={due.toLocaleDateString("ro-RO")}
			color={color}
			variant={variant}
			sx={{
				ml: 1,
				borderRadius: 1,
				fontSize: "0.8rem",
				height: 24,
				animation: animation, 
			}}
		/>
	);
};